import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "tooltip"],
  _excluded2 = ["children", "as", "display"];
import { Tooltip as FoundationsTooltip } from 'foundations-components/transitional/components/Tooltip';
import { LayoutBox } from '../Layout/LayoutBox';
import { useSpacingProps } from '../Layout/useSpacingProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const Tooltip = _ref => {
  let {
      children,
      tooltip
    } = _ref,
    restWithSpacingProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    spacingProps,
    otherProps: rest
  } = useSpacingProps(restWithSpacingProps);
  return /*#__PURE__*/_jsx(FoundationsTooltip, Object.assign({
    title: tooltip
  }, rest, spacingProps, {
    children: children
  }));
};
const TooltipTarget = _ref2 => {
  let {
      children,
      as = 'span',
      display = 'inline-block'
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(LayoutBox, Object.assign({
    as: as,
    display: display
  }, rest, {
    children: children
  }));
};
Tooltip.Target = TooltipTarget;